<template>
  <div class="home">
    <div class="logout">
      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        placement="left-start"
        @select="loginout"
      >
        <template #reference>
          <van-icon name="setting" />
        </template>
      </van-popover>
    </div>
    <!-- header -->
    <div class="header">
      <div class="header-text">
        <div class="hello">
          Hello,{{ shopInfo.userName ? shopInfo.userName : shopInfo.mobile }}
        </div>
        <div class="shopName">{{ shopInfo.name }}</div>
      </div>
    </div>
    <!-- 通知区域 -->
    <div class="notice" v-on:click="showDialog()">
      <div class="icon1"><van-icon name="volume" /></div>
      <div class="text">新手引导 - 消费流程</div>
      <div class="icon2"><van-icon name="arrow" /></div>
    </div>
    <!-- 卡管理区域 -->
    <div class="main-panel">
      <div class="card-manage panel" v-on:click="toCardManage">
        <div class="title">储值卡管理</div>
        <div class="remark">可对储值卡进行充值、消费及查看交易记录</div>
        <div class="icon">
          <van-icon name="vip-card" />
        </div>
      </div>
      <div class="register panel" v-on:click="toMemberCenter">
        <div class="title">会员管理</div>
        <div class="remark">为用户注册山国会员</div>
        <div class="icon">
          <!-- <van-icon name="shop-collect" /> -->
          <van-icon name="friends-o" />
        </div>
      </div>
      <!-- <div class="register panel" v-on:click="toRegisterMember">
        <div class="title">注册会员</div>
        <div class="remark">为用户注册山国会员</div>
        <div class="icon">
          <van-icon name="shop-collect" />
        </div>
      </div> -->
      <div class="custom panel" v-on:click="toOrderCenter">
        <div class="title">订单管理</div>
        <div class="remark">查看打印需求，为客户打印专属茶盒</div>
        <div class="icon">
          <van-icon name="gift-card" />
        </div>
      </div>

      <div class="custom panel" v-on:click="toMyCoupon">
        <div class="title">我的提货卡</div>
        <div class="remark">对提货卡进行激活、退卡等管理</div>
        <div class="icon">
          <van-icon name="coupon" />
        </div>
      </div>
    </div>

    <!-- 弹出说明框 -->
    <van-dialog
      class="home-dialog"
      v-model="show"
      :show-confirm-button="false"
      overlay
      @confirm="showDialog"
    >
      <div class="dialog-middle" v-on:click="showDialog()">
        <div class="close">
          <van-icon name="cross" class="icon" />
        </div>
        <div class="title">消费流程</div>
        <div class="flow">
          <div class="flow-icon">
            <van-icon name="peer-pay" />
            <div class="text">进入储值卡管理，选择储值卡下单</div>
          </div>
          <div class="arrow">
            <hr />
            <van-icon name="play" />
          </div>
          <div class="flow-icon inputPro">
            <van-icon name="shopping-cart-o" />
            <div class="text">输入商品编码加入购物车</div>
          </div>
          <div class="arrow">
            <hr />
            <van-icon name="play" />
          </div>
          <div class="flow-icon submitOrder">
            <!-- <van-icon name="passed" /> -->
            <van-icon name="after-sale" />
            <div class="text">提交订单</div>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import "../../assets/css/index.less";
import { apiPost, queryPost, setWxConfig } from "@/api/common";
// 引入vant组件库

export default {
  name: "Home",
  data() {
    return {
      showCode: false,
      //控制充值框的显示与隐藏
      show: false,
      //店铺信息
      shopInfo: "",
      showPopover: false,
      actions: [{ text: "退出登录" }],
      code: "",
      openId: ""
    };
  },
  components: {},
  created() {
    // alert("is ios:" + browser.versions.ios);
    // alert("is android:" + browser.versions.android);
    // this.$toast.fail("is ios:" + browser.versions.ios);
    // this.$toast.fail("is android:" + browser.versions.android);
    this.loadComments();
    setWxConfig(window.location.href);
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      {
        this.loadPay();
      }
    }
  },
  methods: {
    loadComments() {
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
    },
    getCodeApi() {
      //获取code
      this.urlNow = encodeURIComponent(window.location.href);
      // window.location.href.replace(/(^\w+:|^)\/\//, "")
      // let scope='snsapi_userinfo';    //snsapi_userinfo snsapi_base   //静默授权 用户无感知
      let url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.appId +
        "&redirect_uri=" +
        this.urlNow +
        "&response_type=code&scope=snsapi_base#wechat_redirect";
      window.location.href = url;
    },
    /**
     * 获取URL参数
     * @returns {Object}
     */
    getUrlCode() {
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    //获取appid和appSecrect
    async getAppId() {
      const res = await apiPost("mem/weiChatApplets/getWeChatAppId");
      const appid = res.data.data.results.appId;
      const secret = res.data.data.results.secret;
      this.appId = appid;
      this.secret = secret;
    },
    async loadPay() {
      var that = this;
      await this.getAppId();

      this.code = this.getUrlCode().code; // 截取code
      window.sessionStorage.setItem("code", this.code);
      if (this.code == null || this.code === "") {
        this.getCodeApi();
      } else {
        queryPost("mem/weiChatApplets/getWeChatOpenId", {
          code: this.code
        })
          .then(res => {
            const data = JSON.parse(res.data.data.results);
            if (
              data.openid == null ||
              data.openid == "" ||
              data.openid == undefined
            ) {
              this.getCodeApi();
            }
            window.sessionStorage.setItem("openId", data.openid);
            that.openId = data.openid;
          })
          .catch();
      }
    },
    showDialog() {
      this.show = !this.show;
    },
    toRegisterMember() {
      this.$router.push("/registerMember");
    },
    toMemberCenter() {
      this.$router.push("/memberCenter");
    },
    toCardManage() {
      this.$router.push("/cardManage");
    },
    toOrderCenter() {
      this.$router.push("/orderCenter");
    },
    toMyCoupon() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (
          window.sessionStorage.getItem("openId") === "" ||
          window.sessionStorage.getItem("openId") === null
        ) {
          return;
        } else {
          this.$router.push("/couponList");
        }
      } else {
        this.$router.push("/couponList");
      }
    },
    toBuy() {
      this.$router.push("/buy");
    },
    loginout() {
      localStorage.removeItem("shopInfo");
      this.$router.push("/login");
    }
  }
};
</script>
